module.exports = __webpack_public_path__ + "c056a71ca6379d2dfef6f96bcb65b9ac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-300.woff
// module id = 455
// module chunks = 0